import React from 'react';
import cx from 'classnames';
import css from './Tabs.module.scss';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import { setFilters } from '../../../../store/reducers/filtersSlice';
import { EDirection } from '../../../../store/reducers/enumTypes';

export const Tabs = () => {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.filtersReducer);
  const TABS = [
    {
      name: 'Outgoing',
      key: EDirection.OUTWARD,
      onClick: () => {
        dispatch(setFilters({ ...filters, direction: EDirection.OUTWARD }));
      },
    },
    {
      name: 'Incoming',
      key: EDirection.INWARD,
      onClick: () => {
        dispatch(setFilters({ ...filters, direction: EDirection.INWARD }));
      },
    },
    {
      name: 'Transfers',
      key: EDirection.TRANSFER,
      onClick: () => {
        dispatch(setFilters({ ...filters, direction: EDirection.TRANSFER }));
      },
    },
    {
      name: 'FX',
      key: EDirection.FX,
      onClick: () => {
        dispatch(setFilters({ ...filters, direction: EDirection.FX }));
      },
    },
  ];

  return (
    <ul className={css.root}>
      {TABS.map(({ name, key, onClick }) => (
        <li key={key} className={cx(css.item, key === filters.direction && css.isSelected)} onClick={() => key !== filters.direction && onClick()}>
          {name}
        </li>
      ))}
    </ul>
  );
}
